module.exports = __webpack_public_path__ + "img/IMG_20170616_122529.6b3f6200.jpg";